/**
 * DS-internal hook : ce qui paraît se pose en fondu, à la durée `standard` et à la courbe de la marque ;
 * ce qui s'en va part d'un coup (l'appelant cesse de le rendre, et le fondu repart de zéro). En mouvement
 * réduit, il est là d'emblée. Né pour ce que dit Sam, qui sort de lui une fois l'orbite posée (daily du
 * 23/10 : sa bulle arrivait avant lui).
 */
import { useEffect, useRef } from "react"
import { Animated, Easing, Platform } from "react-native"
import { useUnistyles } from "react-native-unistyles"

import { useReduceMotion } from "./useReduceMotion"

export function useFadeIn(shown: boolean): Animated.Value {
    const { theme } = useUnistyles()
    const reduceMotion = useReduceMotion()
    const opacity = useRef(new Animated.Value(0)).current

    useEffect(() => {
        if (!shown || reduceMotion) {
            opacity.setValue(shown ? 1 : 0)
            return undefined
        }
        const move = Animated.timing(opacity, {
            toValue: 1,
            duration: theme.motion.standard,
            easing: Easing.bezier(...theme.motion.easing),
            // react-native-web n'a pas de pilote natif ; y prétendre ne fait qu'avertir.
            useNativeDriver: Platform.OS !== "web",
        })
        move.start()
        return () => move.stop()
    }, [shown, reduceMotion, opacity, theme.motion])

    return opacity
}
